.Left {
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  position: absolute;
  top: 30px;
  left: 30px;

  svg {
    width: 16px;
    height: 16px;
    margin-right: 10px;
    @include themify($themes) {
      color: themed("font_secondary");
    }
  }

  .Back {
    font-family: $font_family;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    @include themify($themes) {
      color: themed("font_secondary");
    }
  }
}

.Content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
  width: 100%;
  position: relative;
  & .Logo {
    width: 50px;
  }

  .Title {
    @include themify($themes) {
      font-family: $font_family;
      font-style: normal;
      font-weight: 500;
      font-size: 22px;
      color: themed("font_primary");
      margin-bottom: 6px;
      margin-top: 28px;
    }
  }

  .SubTitle {
    @include themify($themes) {
      text-align: center;
      font-family: $font_family;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      color: themed("font_primary");
    }
  }
}

.dynamicsContainer {
  width: fit-content;
  display: flex;
  align-items: center;
  height: fit-content;
  padding: 0 0 30px 30px;
  box-sizing: border-box;
  width: 100%;
  font-size: 0;
  
  @include themify($themes) {
    color: themed("main-primary");
  }
  text-decoration: none;
  font-size: 12px;
  svg {
    height: 36px;
    width: 36px;
  }
}

.compact {
  .needUser {
    text-align: center;
  }
}
